import {decode} from '../../../../utils/base64'

export default async function decodeBase64(input) {
  return decode(input)
}
